// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Отложенная загрузка аватара: не блокирует первый кадр / анимацию загрузки */
.deferred-profile-avatar-wrap {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  contain: strict;
  background: var(--bg-secondary, #f1f5f9);
}

.deferred-profile-avatar-fallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  z-index: 0;
}

.deferred-profile-avatar-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  z-index: 1;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.deferred-profile-avatar-img--visible {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/css/deferred-profile-avatar.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,qDAAqD;EACrD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Отложенная загрузка аватара: не блокирует первый кадр / анимацию загрузки */\n.deferred-profile-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n  overflow: hidden;\n  contain: strict;\n  background: var(--bg-secondary, #f1f5f9);\n}\n\n.deferred-profile-avatar-fallback {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  z-index: 0;\n}\n\n.deferred-profile-avatar-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  z-index: 1;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.deferred-profile-avatar-img--visible {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
